// extracted by mini-css-extract-plugin
export default {"spotlightsImage":"template-three-module__spotlightsImage__i22GW"};